import {
  Button,
  ListItemIcon,
  ListItemText,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLoading } from "../../../providers/loadingProvider";
import { committeeSelector } from "../../../store/advisorSlice";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import service from "../Helpers/gifservices";
import { makeStyles } from "@mui/styles";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import PersonIcon from "@mui/icons-material/Person";
import DeclinePreProposalModal from "../Components/DeclinePreProposalModal";
import { boardDessicion } from "../Constants";
import { useNotify } from "../../../providers/NotificationProvider";
import { Box } from "@mui/system";
import { GifColors } from "../../../theme";
import { Fingerprint } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  proposalName: {
    marginLeft: 10,
    fontWeight: 600,
  },
  button: {
    marginBottom: 2,
    justifyContent: "center",
  },
  approveButton: {
    "&:hover": {
      backgroundColor: theme.palette.gif.blue.hover,
    },
    color: theme.palette.gif.blue.color,
    backgroundColor: theme.palette.gif.blue.background,
  },
  declineButton: {
    "&:hover": {
      backgroundColor: theme.palette.gif.red.hover,
    },
    color: theme.palette.gif.red.color,
    backgroundColor: theme.palette.gif.red.background,
  },
  assignButton: {
    "&:hover": {
      backgroundColor: theme.palette.gif.green.hover
    },
    color: theme.palette.gif.green.color,
    backgroundColor: theme.palette.gif.green.background,
  },
  changeDecisionButton: {
    "&:hover": {
      backgroundColor: theme.palette.gif.yellow.hover,
    },
    color: theme.palette.gif.yellow.dark,
    backgroundColor: theme.palette.gif.yellow.color,
  },
}));

const PreProposalRow = (props) => {
  const { preProposal, refreshPreProposals } = props;
  const classes = useStyles();
  const notify = useNotify();
  const loading = useLoading();
  const [declineModalOpen, setDeclineModalOpen] = useState(false);
    const committee = useSelector(committeeSelector);
  
  const createPDF = async () => {
    const proposalId = preProposal.id;
    if (!Boolean(proposalId)) return;
    const loadingId = loading.addLoading("Downloading Proposal Info");
    const pdfPath = await service.createProposalPDF({ proposalId });
    await service.downloadRawFile({
      path: pdfPath,
      filename: preProposal.name,
    });
    loading.removeLoading(loadingId);
  };

  const assignToMe = async () => {
    const loadingId = loading.addLoading("Assigning pre proposal");
    await service.AssotiateMeToProposal({ proposalId: preProposal.id, committeeId:  committee.committeeId});
    console.log("assign " + preProposal.id);
    loading.removeLoading(loadingId)
  }
  const ApprovePreProposal = () => {
    const loadingId = loading.addLoading("Approving Pre Proposal");
    const proposalId = preProposal.id;
    service
      .UpdatePreProposalCCDecision({
        proposalId: proposalId,
        decision: boardDessicion.Approved,
        decisionReason: null,
      })
      .then(() => {
        refreshPreProposals();
        notify.show("Pre-Proposal approved successfully!");
      })
      .catch((error) => {
        console.error(error);
        notify.show("Pre-Proposal cant approved", {
          severity: "error",
        });
      })
      .finally(() => loading.removeLoading(loadingId));
  };

  const DeclinePreProposal = (decisionReason) => {
    const loadingId = loading.addLoading("Declining Pre Proposal");
    const proposalId = preProposal.id;
    service
      .UpdatePreProposalCCDecision({
        proposalId: proposalId,
        decision: boardDessicion.Dissapproved,
        decisionReason: decisionReason,
      })
      .then(() => {
        refreshPreProposals();
        notify.show("Pre-Proposal Declined successfully!");
      })
      .catch((error) => {
        console.error(error);
        notify.show("Pre-Proposal cant Decline", {
          severity: "error",
        });
      })
      .finally(() => loading.removeLoading(loadingId));
  };

  return (
    <>
      <TableRow>
        <TableCell>
          <Typography className={classes.proposalName}>
            {preProposal.name}
          </Typography>
        </TableCell>
        <TableCell>{preProposal.title}</TableCell>
        <TableCell>
          <List>
            {preProposal.applicants.map((a) => (
              <ListItem key={a.id}>
                <ListItemIcon>
                  <PersonIcon />
                </ListItemIcon>
                <ListItemText primary={a.name} secondary={a.institutionName} />
              </ListItem>
            ))}
          </List>
        </TableCell>
        <TableCell>
          <Typography>{preProposal.nameOfAdvisor}</Typography>
        </TableCell>
        <TableCell>
          {preProposal.boardDessicion === null ? (
            <>
              <Button
                fullWidth
                startIcon={<CheckIcon />}
                className={`${classes.approveButton} ${classes.button}`}
                onClick={ApprovePreProposal}
              >
                Approve
              </Button>
              <Button
                fullWidth
                startIcon={<CloseIcon />}
                className={`${classes.declineButton} ${classes.button}`}
                onClick={() => setDeclineModalOpen(true)}
              >
                Decline
              </Button>
              <Button
                fullWidth
                startIcon={<Fingerprint />}
                className={`${classes.assignButton} ${classes.button}`}
                onClick={() => assignToMe()}
              >
                Assign To Me
              </Button>
            </>
          ) : preProposal.boardDessicion === boardDessicion.Approved ? (
            <Box
              color={GifColors.lightGray}
              marginBottom={1}
              backgroundColor={GifColors.green}
              textAlign="center"
              fontWeight={600}
              fontSize={16}
              padding={1}
              borderRadius={2}
            >
              Approved
            </Box>
          ) : (
            <Tooltip title={preProposal.boardDecisionJustification}>
              <Box
                color={GifColors.lightGray}
                marginBottom={1}
                backgroundColor={GifColors.germanyRed}
                textAlign="center"
                fontWeight={600}
                fontSize={16}
                padding={1}
                borderRadius={2}
              >
                Declined
              </Box>
            </Tooltip>
          )}
          <Button
            fullWidth
            startIcon={<CloudDownloadIcon />}
            className={`${classes.changeDecisionButton} ${classes.button}`}
            onClick={createPDF}
          >
            View PDF
          </Button>
        </TableCell>
      </TableRow>
      <DeclinePreProposalModal
        decline={DeclinePreProposal}
        open={declineModalOpen}
        onClose={() => setDeclineModalOpen(false)}
      />
    </>
  );
};

export default function PreProposals() {
  const loading = useLoading();
  //const classes = useStyles();
  const committee = useSelector(committeeSelector);
  const [preProposals, setPreProposals] = useState([]);
  const tableHeaders = [
    { label: "Pre-proposal Number" },
    { label: "Title" },
    { label: "Applicants and their Institutional Affiliation" },
    { label: "Advisor" },
    { label: "Actions", width: "175px" },
  ];

  const getPreProposals = useCallback(async () => {
    if (!committee) return;
    const loadingId = loading.addLoading("Loading Pre Proposals");
    const committeeId = committee.committeeId;
    const preProposals = await service.GetCommitteePreProposals({
      committeeId,
    });
    setPreProposals(preProposals.sort((a,b) => a.name > b.name ? 1 : -1));
    loading.removeLoading(loadingId);
  }, [committee, loading]);

  useEffect(() => {
    getPreProposals();
  }, [getPreProposals]);

  return (
    <>
    <div>
    <Typography variant="body" fontWeight={700} align="center" display={'block'}>
    **Please note that once you approve a pre-proposal, it will be assigned to you for the entire peer-review process** 
    </Typography>
    </div>
    <TableContainer>
      
      <Table>
        <TableHead>
          <TableRow>
            {tableHeaders.map((header) => (
              <TableCell key={header.label} style={{ width: header.width }}>
                {header.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {preProposals.map((preProposal) => (
            <PreProposalRow
              key={preProposal.id}
              preProposal={preProposal}
              refreshPreProposals={getPreProposals}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    </>
  );
}
